<template>
  <div class="evaluation-form-container">
    <!-- 页面标题 -->
    <div class="backbtn">
      <el-button class="goback-button" size="small" @click="goBackFn">
        <i class="el-icon-back"></i> 返回
      </el-button>
    </div>
    <div class="form-header">
      <h1>企业数字化水平评测表单</h1>
    </div>
    <div class="image-uploader">
      <!-- 标题 -->
      <div class="upload-title">定级评测计划</div>
      <!-- 上传区域 -->
      <el-upload
        class="uploader"
        action="/dev/minio"
        :before-upload="beforeUpload"
        :headers="headers"
        :on-success="handlePlanSuccess"
        :on-remove="handlePlanRemove"
        :on-error="handleError"
        :file-list="planFile"
        :limit="1"
        :on-exceed="handleExceed"
        list-type="picture-card"
        accept="image/*"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <!-- 标题 -->
      <div class="upload-title">定级评测签到表</div>
      <!-- 上传区域 -->
      <el-upload
        class="uploader"
        action="/dev/minio"
        :before-upload="beforeUpload"
        :headers="headers"
        :on-success="handleSceneSuccess"
        :on-remove="handleSceneRemove"
        :on-error="handleError"
        :file-list="signInFile"
        :limit="1"
        :on-exceed="handleExceed"
        list-type="picture-card"
        accept="image/*"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <!-- 标题 -->
      <div class="upload-title">现场评测记录表</div>
      <!-- 上传区域 -->
      <el-upload
        class="uploader"
        action="/dev/minio"
        :before-upload="beforeUpload"
        :headers="headers"
        :on-success="handleRecordSuccess"
        :on-remove="handleRecordRemove"
        :on-error="handleError"
        :file-list="recordFile"
        :limit="1"
        :on-exceed="handleExceed"
        list-type="picture-card"
        accept="image/*"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <div class="upload-title">
        试点企业评测现场图片<span style="color: #ffcc00"
          >（注意：评测现场图片需带有日期、时间、地点等信息的水印）</span
        >
      </div>
      <div class="upload-boxes">
        <!-- 第二个上传框 -->
        <div class="upload-box left-box">
          <el-upload
            class="uploader"
            action="/dev/minio"
            :before-upload="beforeUpload"
            :headers="headers"
            :on-success="handleEnterpriseSuccess"
            :on-error="handleError"
            :on-remove="handleEnterpriseRemove"
            :file-list="reviewSiteFiles"
            :limit="2"
            :on-exceed="handleEnterpriseExceed"
            list-type="picture-card"
            accept="image/*"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
        <!-- 预览对话框 -->
        <el-dialog :visible.sync="previewVisible" append-to-body>
          <img width="100%" :src="previewImage" alt="" />
        </el-dialog>
      </div>
    </div>
    <!-- 评测题目列表 -->
    <div class="question-list">
      <!-- 循环渲染每个题目 -->
      <div
        class="question-item"
        v-for="(question, index) in questionList"
        :key="index"
      >
        <!-- 题目标题 -->
        <div class="question-header" @click="toggleQuestion(index)">
          <span class="question-number">{{ index + 1 }}.</span>
          <span class="question-title">{{ question.name }}</span>
          <i
            class="el-icon-arrow-down toggle-icon"
            v-if="!question.expanded"
          ></i>
          <i class="el-icon-arrow-up toggle-icon" v-else></i>
        </div>

        <div class="question-content" v-show="question.expanded">
          <!-- 选项 -->
          <div class="selected-data">
            <div class="selected-title">选项</div>
            <div
              v-for="(item, index) in question.options"
              :key="index"
              class="selected-item"
            >
              <el-checkbox
                :checked="item.isAns === 1"
                :label="item.name"
                disabled
              ></el-checkbox>
            </div>
          </div>

          <div class="file-list">
            <div class="selected-title">佐证材料</div>
            <template v-if="question.fileList && question.fileList.length > 0">
              <div
                class="file-item"
                v-for="(file, fileIndex) in question.fileList"
                :key="fileIndex"
              >
                <span
                  @click="showImg(file.path, file.type)"
                  class="file-name"
                  >{{ file.name }}</span
                >
              </div>
            </template>
            <div v-else class="no-data">无</div>
          </div>
          <!-- 专家佐证材料 -->
          <div class="img-uploader">
            <!-- 标题 -->
            <div class="selected-title">专家佐证材料</div>
            <el-upload
              :headers="headers"
              :limit="1"
              :on-exceed="handleExcelExceed"
              v-if="question.id == 11"
              class="uploader"
              action="/dev/minio"
              :before-upload="beforeExcelUpload"
              :on-success="
                (res, file, fileList) => handleExcelSuccess(res, file, fileList)
              "
              :file-list="question.expertFileList"
              :on-remove="(file, fileList) => handleExcelRemove(file, fileList)"
              :on-error="handleError"
              :on-preview="handleExpertDownload"
              accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div v-else-if="question.id == 18" class="no-data">同第2题一样</div>
            <el-upload
              v-else
              class="uploader"
              action="/dev/minio"
              :headers="headers"
              :before-upload="beforeExpertUpload"
              :on-success="
                (res, file, fileList) =>
                  handleExpertSuccess(
                    res,
                    file,
                    fileList,
                    question.id,
                    question.questionType
                  )
              "
              :on-error="handleError"
              :on-remove="
                (file, fileList) =>
                  handleExpertRemove(
                    file,
                    fileList,
                    question.id,
                    question.questionType
                  )
              "
              :file-list="question.expertFileList"
              list-type="picture-card"
              accept="image/*"
            >
              <i class="el-icon-plus"></i>
            </el-upload>

            <draggable
              v-model="question.expertFileList"
              @end="onDragEnd"
              v-if="question.expertFileList.length > 1"
              class="draggable-item"
            >
              <div
                v-for="file in question.expertFileList"
                :key="file.id"
                class="sortable-item"
              >
                <img :src="file.url" class="preview-image" />
              </div>
            </draggable>
          </div>

          <!-- 证据采集参考 -->
          <div class="reference-section">
            <div class="section-title">证据采集参考</div>
            <div class="reference-content">
              {{ question.evidenceCollectionReferences }}
            </div>
          </div>

          <!-- 现场评定意见 -->
          <div class="assessment-section">
            <div class="section-title">现场评定意见</div>
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="question.onSiteAssessmentOpinions"
              class="assessment-textarea"
            >
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- 生成佐证按钮 -->
    <div class="generate-button-container">
      <div class="button-group">
        <div v-if="generated" class="timeBox">
          <span class="timer">上一次生成时间:{{ parseTime }}</span>
          <el-button type="primary" class="download-button" @click="downloadFn">
            <i class="el-icon-download"></i> 下载佐证文件
          </el-button>
        </div>
        <el-button type="primary" class="generate-button" @click="saveFn">
          {{ generated ? "更新佐证" : "生成佐证" }}
        </el-button>
      </div>
    </div>
    <!-- 展示图片-->
    <el-dialog :visible.sync="dialogVisible" width="50%">
      <img :src="currentImgUrl" alt="" style="width: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import store from "../../../../store";
import draggable from "vuedraggable";
import { getData, saveData, downloadReport, downWord } from "@/api/evidence";
import * as XLSX from "xlsx";

export default {
  components: { draggable },
  name: "EvaluationForm",
  props: ["userId"],
  data() {
    return {
      parseTime: "", //生成时间
      headers: { Authorization: "Bearer " + store.getters.token },
      planFile: [], //定级评测计划
      signInFile: [], // 定级评测签到表
      recordFile: [], //现场评测记录表
      reviewSiteFiles: [], // 企业评测现场
      dialogVisible: false,
      currentImgUrl: "",
      previewImage: "",
      previewVisible: false,
      totalData: {},
      questionList: [],
      generated: false, //是否生成过
    };
  },
  created() {
    this.getQuestions();
  },
  methods: {
    // 获取题目数据
    async getQuestions() {
      const res = await getData(this.userId);
      this.totalData = res.data;
      const questions = res.data.treeNode;
      this.generated = res.data.generatorWordTime ? true : false;
      this.parseTime = res.data.generatorWordTime;
      //处理定级评测计划图片
      if (res.data.evaluationPlanFile) {
        const obj = res.data.evaluationPlanFile;
        obj.url = obj.path;
        delete obj.path;
        this.planFile.push(obj);
      } else {
        this.planFile = [];
      }
      //处理定级评测签到表图片
      if (res.data.signInFile) {
        const obj = res.data.signInFile;
        obj.url = obj.path;
        delete obj.path;
        this.signInFile.push(obj);
      } else {
        this.signInFile = [];
      }
      //处理现场评测记录表图片
      if (res.data.reviewSiteRecordFile) {
        const obj = res.data.reviewSiteRecordFile;
        obj.url = obj.path;
        delete obj.path;
        this.recordFile.push(obj);
      } else {
        this.recordFile = [];
      }
      //处理企业评测2张图片
      if (res.data.reviewSiteFiles) {
        const siteFile = res.data.reviewSiteFiles;
        this.reviewSiteFiles = siteFile.map((item) => {
          const { path, ...rest } = item;
          return {
            url: path,
            ...rest,
          };
        });
      } else {
        this.reviewSiteFiles = [];
      }
      this.questionList = questions.map((question, index) => ({
        ...question,
        expanded: index === 0,
        expertFileList: question.expertFileList.map((item) => ({
          ...item,
          url: item.path,
        })),
      }));
      console.log(this.questionList);
    },
    //保存提交
    async saveFn() {
      this.questionList.forEach((question) => {
        question.expertFileIds = JSON.stringify(question.expertFileList);
      });
      let signInFileId = "";
      let planFileId = "";
      let recordFileId = "";

      if (this.planFile.length > 0) {
        planFileId = this.planFile[0].id || "";
      } else {
        this.$message.error("定级评测计划需要上传一张图片");
        return;
      }
      if (this.signInFile.length > 0) {
        signInFileId = this.signInFile[0].id || "";
      } else {
        this.$message.error("定级评测签到表需要上传一张图片");
        return;
      }
      if (this.recordFile.length > 0) {
        recordFileId = this.recordFile[0].id || "";
      } else {
        this.$message.error("现场评测记录表需要上传一张图片");
        return;
      }
      if (this.reviewSiteFiles.length < 2) {
        this.$message.error("试点企业评测现场需要上传两张图片");
        return;
      }
      const FileIds = this.reviewSiteFiles.map((item) => item.id);
      const submitData = {
        userId: this.totalData.userId,
        reportId: this.totalData.reportId,
        evaluationPlanFileId: planFileId,
        signInFileId: signInFileId,
        reviewSiteRecordFileId: recordFileId,
        reviewSiteFileIds: FileIds,
        treeNode: this.questionList,
      };

      const res = await saveData(submitData);
      if (res.code == 200) {
        this.generated = true;
        this.parseTime = this.formatDate(res.data);
        this.$message.success("佐证材料保存成功");
      } else {
        this.$message.error("佐证材料保存失败");
      }
    },
    // 专家佐证上传成功
    handleExpertSuccess(response, file, fileList, questionId, questionType) {
      const uploadedFile = {
        name: file.name,
        url: response.url || file.url,
        id: response.data.id,
        status: "success",
      };

      const questionIndex = this.questionList.findIndex(
        (q) => q.id === questionId && q.questionType === questionType
      );
      console.log(questionIndex);

      if (questionIndex !== -1) {
        this.questionList[questionIndex].expertFileList.push(uploadedFile);
        this.$set(
          this.questionList,
          questionIndex,
          this.questionList[questionIndex]
        );
      }
      this.$message.success("专家佐证材料上传成功");
    },
    //专家佐证excel下载
    async handleExpertDownload(file) {
      const response = await downWord(file.id);
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", file.name); // 设置文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    },

    //excel上传成功
    handleExcelSuccess(response, file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const workbook = XLSX.read(e.target.result, { type: "buffer" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils
          .sheet_to_json(worksheet, { header: 0, raw: false })
          .slice(1)
          .map((v) => Object.values(v));
        const all = jsonData.filter((v) => v[4]);
        const digit = all.filter((v) => v[11] === "是");
        const online = all.filter((v) => v[10] === "是");
        const form = {
          list: [],
          all: 0,
          digit: 0,
          online: 0,
          digitRate: 0,
          onlineRate: 0,
        };
        form.list = jsonData.map((v) => ({
          plant: v[1],
          line: v[2],
          code: v[3],
          name: v[4],
          type: v[5],
          size: v[6],
          factory: v[7],
          date: v[8],
          status: v[9],
          online: v[10],
          digit: v[11],
          real: v[12],
          during: v[13],
          last: v[14],
        }));
        form.all = all.length;
        form.digit = digit.length;
        form.online = online.length;
        form.digitRate = ((form.digit / (form.all || 1)) * 100).toFixed(2);
        form.onlineRate = ((form.online / (form.all || 1)) * 100).toFixed(2);
        this.questionList[1].expertOtherAns = JSON.stringify(form);
        this.questionList[1].expertExcelFileId = response.data.id;
        this.questionList[1].expertFileList.push(response.data);
      };
      reader.readAsArrayBuffer(file.raw);
    },
    //专家佐证删除
    handleExpertRemove(file, fileList, questionId, questionType) {
      const questionIndex = this.questionList.findIndex(
        (q) => q.id === questionId && q.questionType === questionType
      );
      if (questionIndex === -1) return;
      this.questionList[questionIndex].expertFileList = this.questionList[
        questionIndex
      ].expertFileList.filter((item) => item.id !== file.id);
      this.$set(
        this.questionList,
        questionIndex,
        this.questionList[questionIndex]
      );
    },
    //第二题专家佐证删除
    handleExcelRemove(file, fileList) {
      const newFileList = this.questionList[1].expertFileList.filter(
        (item) => item.id !== file.id
      );
      this.questionList[1].expertExcelFileId = "";
      this.questionList[1].expertOtherAns = "";
      this.$set(this.questionList[1], "expertFileList", newFileList);
    },

    // 定级评测签到表上传成功
    handleSceneSuccess(response, file) {
      this.signInFile.push({
        name: file.name,
        url: file.url,
        id: response.data.id,
      });
    },
    //定级评测计划上传成功
    handlePlanSuccess(response, file) {
      this.planFile.push({
        name: file.name,
        url: file.url,
        id: response.data.id,
      });
    },
    //现场评测记录表上传成功
    handleRecordSuccess(response, file) {
      this.recordFile.push({
        name: file.name,
        url: file.url,
        id: response.data.id,
      });
    },
    // 企业评测现场图片上传成功
    handleEnterpriseSuccess(response, file) {
      this.reviewSiteFiles.push({
        name: file.name,
        url: file.url,
        id: response.data.id,
      });
    },
    //定级评测签到表删除
    handleSceneRemove(file, flieList) {
      this.signInFile = this.signInFile.filter((item) => item.id !== file.id);
    },
    //定级评测计划删除
    handlePlanRemove(file, flieList) {
      this.planFile = this.planFile.filter((item) => item.id !== file.id);
    },
    //现场评测记录表删除
    handleRecordRemove(file, flieList) {
      this.recordFile = this.recordFile.filter((item) => item.id !== file.id);
    },
    //企业评测删除
    handleEnterpriseRemove(file, flieList) {
      this.reviewSiteFiles = this.reviewSiteFiles.filter(
        (item) => item.id !== file.id
      );
    },
    // 上传前的校验方法
    beforeUpload(file) {
      const isImage = file.type.includes("image/");
      if (!isImage) {
        this.$message.error("上传文件只能是图片格式!");
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }
      return true;
    },
    // excel上传前校验
    beforeExcelUpload(file) {
      const allowedTypes = [
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      ];
      const isExcel = allowedTypes.includes(file.type);
      if (!isExcel) {
        this.$message.error("第二题的专家佐证材料只能是Excel格式!");
        return false;
      }
      return true;
    },
    //专家佐证上传前校验
    beforeExpertUpload(file) {
      const isImage = file.type.includes("image/");
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error("上传文件只能是图片格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 2MB!");
        return false;
      }
      return true;
    },
    //调顺序后回调
    onDragEnd(newFile) {
      this.$set(
        this.questionList,
        "expertFileList",
        this.questionList.expertFileList
      );
    },
    //下载报告
    async downloadFn() {
      const res = await downloadReport(this.userId);
      // console.log(res);
      if (res.id) {
        const response = await downWord(res.id);
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", res.name); // 设置文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }
    },
    showImg(pathUrl, fileType) {
      if (["image/jpeg", "image/jpg", "image/png"].includes(fileType)) {
        this.currentImgUrl = pathUrl;
        this.dialogVisible = true;
      } else if (fileType === "application/pdf") {
        window.open(pathUrl, "_blank");
      } else {
        const link = document.createElement("a");
        link.href = pathUrl;
        link.download = "";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    async renderPdf(url) {
      const loadingTask = pdfjsLib.getDocument(url);
      const pdf = await loadingTask.promise;
      // 渲染逻辑（如转成 Canvas 或逐页渲染）
    },
    // 上传失败回调
    handleError(err, file) {
      console.error("上传失败", err);
      this.$message.error("上传失败");
    },
    handleExcelExceed() {
      this.$message.warning("这里上传 1 个文件");
    },
    handleExceed() {
      this.$message.warning("这里上传 1 张图片");
    },
    handleEnterpriseExceed() {
      this.$message.warning("这里上传 2 张图片");
    },
    // 切换题目展开/折叠状态
    toggleQuestion(index) {
      this.questionList[index].expanded = !this.questionList[index].expanded;
    },
    goBackFn() {
      this.$emit("close");
    },
    formatDate(dates) {
      const date = new Date(dates);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")} ${String(
        date.getHours()
      ).padStart(2, "0")}:${String(date.getMinutes()).padStart(
        2,
        "0"
      )}:${String(date.getSeconds()).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.timer {
  margin-right: 20px;
}
.timeBox {
  color: #909399;
  font-size: 14px;
}
.draggable-item {
  display: flex;
}

.sortable-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}

.sortable-item {
  border: #909399 1px solid;
  margin-left: 10px;
  position: relative;
  cursor: move;
  transition: all 0.3s;
}
.preview-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}
.paste-area {
  width: 100%;
  height: 160px;
  background-color: white;
  border: 1px solid #e6e6e6;
}
.paste-area:focus {
  border-color: #3d73ea;
}
/* 粘贴后的图片容器 */
.images-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  max-height: 100%;
}
/* 单个图片容器 */
.image-item {
  width: 150px;
  height: 150px;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f5f5f5; /* 可选：图片背景色 */
}
.selected-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  margin-bottom: 8px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.image-uploader {
  background-color: #f5f7fa;
}
::v-deep .el-upload--picture-card {
  background-color: white;
  border: 1px solid #e6e6e6;
  width: 160px;
  height: 130px;
}
::v-deep .el-upload--picture-card i {
  font-size: 60px;
  color: #cdd0d5;
}
.upload-boxes {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
}
.upload-title {
  margin-left: 20px;
  font-size: 14px;
  font-weight: bold;
  color: #3d73ea;
}
.uploader {
  padding: 20px;
  background-color: transparent;
}
.selected-title {
  font-size: 14px;
  color: #3d73ea;
  font-weight: bold;
}

.evaluation-form-container {
  width: 100%;
  /* max-width: 800px; */
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  font-family: "Microsoft YaHei", sans-serif;
}

.form-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e6e6e6;
}

.form-header h1 {
  color: #333;
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.question-list {
  margin-top: 10px;
}

.question-item {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  margin-bottom: 15px;
  overflow: hidden;
  background-color: #fff;
}

.question-header {
  padding: 12px 15px;
  background-color: #f5f7fa;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
}
.no-data {
  margin-left: 30px;
  color: #999;
  /* font-style: italic; */
  padding: 8px 0;
  font-size: 18px;
}
.question-number {
  margin-right: 8px;
  color: #409eff;
  font-weight: bold;
}

.question-title {
  flex: 1;
  color: #0c52e8;
}

.toggle-icon {
  font-size: 12px;
  color: #666;
}

.question-content {
  padding: 15px;
  background-color: #fff;
}

.file-list {
  margin-bottom: 15px;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  margin-bottom: 8px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.file-checkbox {
  margin-right: 10px;
}

.file-name {
  flex: 1;
  color: #333;
  font-size: 13px;
}

.file-actions {
  display: flex;
}
.img-actions {
  display: flex;
}

.action-icon {
  margin-left: 10px;
  color: #909399;
  cursor: pointer;
  font-size: 14px;
}

.section-title {
  color: #333;
  font-weight: bold;
  margin: 15px 0 8px 0;
  font-size: 13px;
  padding-left: 5px;
  border-left: 3px solid #409eff;
}

.reference-content {
  background-color: #f5f7fa;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 10px;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  white-space: pre-line;
}

.assessment-textarea {
  margin-bottom: 10px;
}

.generate-button-container {
  text-align: center;
  margin-top: 20px;
  padding-top: 15px;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
}

.generate-button {
  width: 150px;
  height: 36px;
  font-size: 14px;
}

.download-button {
  width: 150px;
  height: 36px;
  font-size: 14px;
}

.el-button [class*="el-icon-"] + span {
  margin-left: 5px;
}

/* 调整Element UI组件样式 */
.el-textarea__inner {
  border-radius: 4px;
  border-color: #dcdfe6;
  font-family: "Microsoft YaHei", sans-serif;
  font-size: 13px;
  resize: none;
  padding: 8px 10px;
}

.el-checkbox {
  margin-right: 8px;
}

.el-checkbox__inner {
  width: 16px;
  height: 16px;
  border-radius: 3px;
}

.el-checkbox__inner::after {
  height: 8px;
  left: 5px;
  top: 1px;
  width: 4px;
}
</style>